import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import cx from 'classnames';
import TextField from '@material-ui/core/TextField';
import _ from 'lodash';
import {styles} from '../styling/component/CourseFilterDrawer'

import {
  WithStyles,
  Drawer,
  Grid,
  Typography
} from '@material-ui/core';

import {
  CloseOutlined as CloseIcon,
} from '@material-ui/icons';

import {
  MyPATIconButton,
  SearchField,
} from '../../common';
import { bindActionCreators } from 'redux';


interface CourseFilterDrawerProps extends WithStyles<typeof styles> {
  isFilterDrawerOpen: boolean;
  onFilterDrawerClose: () => void;
  createContentGoals: any;
  setFilterValue:Function;
  filterGoals:any;
  onFilterChange:Function;
  gradeList:any;
  filteredData:any;
  filterFlag:string;
  
}

interface CourseFilterDrawerState {
  suggestedList: any;
	showSuggestedList: boolean;
}


class CourseFilterDrawer extends Component<CourseFilterDrawerProps, CourseFilterDrawerState> {
	constructor(props: CourseFilterDrawerProps) {
		super(props);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleGoalsChange = this.handleGoalsChange.bind(this);
    this.showSuggested=this.showSuggested.bind(this)
    this.searchSuggestedList=this.searchSuggestedList.bind(this);
    this.state = ({
        showSuggestedList: false,
        suggestedList: [],
    });
  }
  handleStatusChange(event:any){
    this.props.onFilterChange("status",event.currentTarget.value)
  }

  handleGoalsChange(id:any){
    this.props.onFilterChange("goals",id)
  }

  handleGradeChange(id:any){
    this.props.onFilterChange("grade",id)
  }

  handleStartDateChange(event:any){
    this.props.onFilterChange("startDate", event.currentTarget.value)
  }

  handleEndDateChange(event:any){
    this.props.onFilterChange("endDate", event.currentTarget.value)
  }

  handleSortChange(event:any){
    this.props.onFilterChange("sortBy",event.currentTarget.value)
    this.props.onFilterDrawerClose();
  }


	showSuggested(action: boolean) {
		if (action) {
			this.setState({ showSuggestedList: true });
		} else {
			setTimeout(() => { this.setState({ showSuggestedList: false }); }, 200)
		}
  }
  
  searchSuggestedList(event: any) {
    var self = this;
    let searchTxt = event.target.value;
    const {createContentGoals} = this.props;
		var courseID = (window.location.href)
		courseID = courseID.substring(courseID.lastIndexOf("/") + 1, courseID.length)

		if (searchTxt == "") {
			self.setState({
				suggestedList: []
			})
		}

		if (searchTxt.length < 2) {
			return
		}

    var _searchedArr = createContentGoals.filter(function(v:any){
        return ((v.name).toLowerCase()).indexOf(searchTxt.toLowerCase()) > -1
    })

    this.setState({
      suggestedList:_searchedArr
    })
	}

  addToGoals(e:any,goalsData:any){
    e.preventDefault()
    this.props.onFilterChange("goals",goalsData._id)
  }

	render() {
    let { classes ,onFilterDrawerClose,isFilterDrawerOpen,createContentGoals,gradeList,filteredData,filterFlag} = this.props;
    let {showSuggestedList,suggestedList} = this.state;
    let gradeData = filteredData.grade || []
    let goalsData = filteredData.goals || []
    let statusData = filteredData.status || []
    let startDate = filteredData.startDate || ""
    let endDate = filteredData.endDate || ""
    let gradeArr = gradeList || [];
    let _self = this;
    let _selectedGoals = (createContentGoals).slice(2)
    let _checkSelectedArray = _selectedGoals.filter(function(v:any){
      return goalsData.indexOf(v._id) > -1
    })

		return (
			<>
			<Drawer
      anchor="right"
      open={isFilterDrawerOpen}
      onClose={onFilterDrawerClose}
      classes={{ paper: classes.drawerPaper }}
    > 
    {
      filterFlag == "Course Filter" ?
  
      <Grid container>
        <Grid item xs={12} className={classes.drawerHeader}>
          <Typography variant="h6" noWrap className={classes.drawerTitle}>Filters</Typography>
          <MyPATIconButton buttonVariant="transparent" onClick={onFilterDrawerClose}>
            <CloseIcon classes={{ root: classes.iconRoot }} />
          </MyPATIconButton>
        </Grid>

        <Grid item xs={12} className={classes.drawerBody}>
          <Typography variant="body1" className={classes.detailsTitle}>Status</Typography>
          <FormGroup>
            <FormControlLabel
              control={<Checkbox defaultChecked={statusData.indexOf("PUBLISHED") > -1 ? true : false} onChange={(e)=>_self.handleStatusChange(e)} value="PUBLISHED" />}
              label="Published"
              className={classes.label}
            />
            <FormControlLabel
              control={<Checkbox defaultChecked={statusData.indexOf("DRAFT") > -1 ? true : false} onChange={(e)=>_self.handleStatusChange(e)} value="DRAFT" />}
              label="Draft"
              className={classes.label}
            />
            <FormControlLabel
              control={
                <Checkbox defaultChecked={statusData.indexOf("LIVE") > -1 ? true : false} onChange={(e)=>_self.handleStatusChange(e)} value="LIVE" />
              }
              label="Live"
              className={classes.label}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={12} className={classes.drawerBody}>
          <Typography variant="body1" className={classes.detailsTitle}>Goal</Typography>
          <FormGroup>
            {createContentGoals.map(function (v: any, i: any) {
              if(i>1){
                return
              }
              return <FormControlLabel
                key={i}
                control={<Checkbox key={`check${i}`} checked={goalsData.indexOf(v._id) > -1 ? true : false} onChange={()=>_self.handleGoalsChange(v._id)} value={v._id} />}
                label={v.name} 
                className={classes.label}
              />
            })
            }
            {_checkSelectedArray.map(function (v: any, i: any) {
              return <FormControlLabel
                key={i}
                control={<Checkbox key={`check${i}`} checked={goalsData.indexOf(v._id) > -1 ? true : false} onChange={()=>_self.handleGoalsChange(v._id)} value={v._id} />}
                label={v.name}
                className={classes.label}
              />
            })
            }
          </FormGroup>
          <Grid item xs={12}  className={cx(classes.drawerBody,classes.label)}>
            <div className={classes.suggestContainer}>
              <SearchField
                placeholder="Search More Goals."
                className={classes.searchRoot}
                onFocus={() => { this.showSuggested(true) }}
                onBlur={() => { this.showSuggested(false) }}
                onChange={this.searchSuggestedList}
                fullWidth
              />
              {
                showSuggestedList && suggestedList.length > 0 && (
                  <ul className={classes.suggestList}>
                    {
                      _.map(suggestedList, (sl: any, i: number) => (
                        <li key={`suggest_${i}`} onClick={(e)=> _self.addToGoals(e,sl)} className={classes.suggestItem}>
                          {sl.name}
                        </li>
                      ))
                    }
                  </ul>
                )
              }
            </div>
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.drawerBody}>
          <Typography variant="body1" className={classes.detailsTitle}>Grade</Typography>
          <FormGroup>
            {gradeArr.map(function (v: any, i: any) {
                return <FormControlLabel
                  control={<Checkbox defaultChecked={gradeData.indexOf(v._id) > -1 ? true : false} onChange={()=>_self.handleGradeChange(v._id)} value={v._id} />}
                  label={v._id}
                  className={classes.label}
                />
              })
              }
          </FormGroup>
          <div className={`col-sm-6 ${classes.marginTop10}`} style={{border:"1px solid #dfdfdf",borderRadius:"5px" ,padding: "10px"}}>
          <Typography variant="body1" className={classes.detailsTitle}>Create Date</Typography>
          <Typography>Start Date :</Typography>  
          <TextField
              id="datetime"
              type="date"
              defaultValue={startDate}
              variant="outlined"
              placeholder="Start Date"
              onChange={this.handleStartDateChange.bind(this)}
              fullWidth margin="dense"
            />
            <Typography>End Date :</Typography>
            <TextField
              id="datetime"
              type="date"
              defaultValue={endDate}
              placeholder="End Date"
              variant="outlined"
              onChange={this.handleEndDateChange.bind(this)}
              fullWidth margin="dense"
            />
          </div>
          
        </Grid>
      </Grid>

      :
      <Grid container>
      <Grid item xs={12} className={classes.drawerHeader}>
        <Typography variant="h6" noWrap className={classes.drawerTitle}>Sorting Options</Typography>
        <MyPATIconButton buttonVariant="transparent" onClick={onFilterDrawerClose}>
          <CloseIcon classes={{ root: classes.iconRoot }} />
        </MyPATIconButton>
      </Grid>

      {/* Sorting options are i) createdAtDesc - newest to oldest ii) createdAtAsc - oldest to newest iii) publishedAtDesc - newest to oldest publishedAt iv) publishedAtAsc - oldest to newest publishedAt

other i) page ii) limit */}
      <Grid item xs={12} className={classes.drawerBody}>
      <Typography variant="body1" className={classes.detailsTitle}>Created At</Typography>
 
          <FormGroup>
            <FormControlLabel
              control={<Checkbox defaultChecked={statusData.indexOf("createdAt") > -1 ? true : false} onChange={(e)=>_self.handleSortChange(e)} value="createdAtDesc" />}
              label="Newest to Oldest"
              className={classes.label}
            />
            <FormControlLabel
              control={<Checkbox defaultChecked={statusData.indexOf("publishedAt") > -1 ? true : false} onChange={(e)=>_self.handleSortChange(e)} value="createdAtAsc" />}
              label="Oldest to Newest"
              className={classes.label}
            />
          </FormGroup>
        </Grid>

        <Grid item xs={12} className={classes.drawerBody}>
          <Typography variant="body1" className={classes.detailsTitle}>Published At</Typography>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked={statusData.indexOf("createdAt") > -1 ? true : false} onChange={(e)=>_self.handleSortChange(e)} value="publishedAtDesc" />}
                  label="Newest to Oldest"
                  className={classes.label}
                />
                <FormControlLabel
                  control={<Checkbox defaultChecked={statusData.indexOf("publishedAt") > -1 ? true : false} onChange={(e)=>_self.handleSortChange(e)} value="publishedAtAsc" />}
                  label="Oldest to Newest"
                  className={classes.label}
                />
              </FormGroup>
          </Grid>

      </Grid>
      }
    </Drawer>
			</>
		)
	}
}
// @ts-ignore
export default (withStyles(styles)(CourseFilterDrawer));
